<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import {  DocumentArrowUpIcon, ScaleIcon  } from '@heroicons/vue/24/outline';
import API from '@/services/api';
import FileInput from '@/components/files/FileInput.vue';
// import FilePond from '../files/FilePond.vue';
import AlertModal from "../ui/modals/AlertModal.vue";
import SelectDocumentType from '../files/SelectDocumentType.vue';
import type { LoadedFile } from '../files/types';
import { useNotificationStore } from '@/store';

const emits = defineEmits(["update"]);
const showModal = ref(false);
const newFiles = ref<LoadedFile[]>([]);
const props = defineProps<{
  claimId: string;
}>()

async function addClaimDocument(files: LoadedFile[]) {
  let axiosResponse;
  const waitNotification = useNotificationStore().emitNotification({
    type: "wait",
    title: "Assignation en cours d'envoi"
  })
  for (const { file, content, documentType } of files) {
    axiosResponse = API.addClaimDocument(props.claimId, {
      name: file.name,
      document: content,
      mimeType: file.type,
      claimDocumentType: "LEGAL_SUBPOENA_TO_REVIEW"
    });
  }
  watch(axiosResponse.data, async (data) => {
    if (data) {
      useNotificationStore().emitNotification({
        title: "Assignation transmise avec succès",
        type: "success",
      });
      waitNotification.duration = 0;
      emits("update");
    }
  })
  closeModalAddDocument()
}
function closeModalAddDocument() {
  showModal.value = false;
  newFiles.value = [];
}
</script>
<template>
  <AlertModal :open="showModal"
    @confirm="addClaimDocument(newFiles)"
    @close="closeModalAddDocument" @cancel="closeModalAddDocument"
    
    title="Ajouter l'assignation"
    message="Une fois envoyé, une tâche de relecture sera assigné au cabinet d'avocat."
    confirmMessage="Envoyer aux avocats"
    :cancelHandler="() => { showModal = false; newFiles = [] }" type="info"
  >

    <div class="pt-2 pb-6">
      <FileInput @files-updated="(files) => newFiles = files" button-text="Sélectionner l'assignation" accept=".docx,.doc" />
    </div>
    
    <!-- <div class="py-2">
      <SelectDocumentType v-if="newFiles.length" @selection-update="(type) => newFiles[0].documentType = type" />
    </div> -->

  </AlertModal>

  <div class="bg-white shadow sm:rounded-lg">
    <div class="px-4 py-5 sm:p-6">
      <div class="flex justify-center text-base font-semibold leading-6 text-gray-800">
        <ScaleIcon class="w-5 mr-2 text-gray-600" />
        Assignation requise
      </div>
      <div class="mt-5">
        <div class="px-6 py-5 border border-blue-200 rounded-md bg-blue-50 sm:flex sm:items-start sm:justify-between">
          <h4 class="sr-only">Assignation</h4>
          <div class="sm:flex sm:items-start ">
            <img class="w-10 h-10 rounded-full" src="https://ucarecdn.com/e3e80df2-387a-4bb4-b48c-623273ab7a4d/" alt="Word" />
            <!-- <svg class="w-auto h-8 sm:h-6 sm:flex-shrink-0" viewBox="0 0 36 24" aria-hidden="true">
              <rect width="36" height="24" fill="#224DBA" rx="4" />
              <path fill="#fff" d="M10.925 15.673H8.874l-1.538-6c-.073-.276-.228-.52-.456-.635A6.575 6.575 0 005 8.403v-.231h3.304c.456 0 .798.347.855.75l.798 4.328 2.05-5.078h1.994l-3.076 7.5zm4.216 0h-1.937L14.8 8.172h1.937l-1.595 7.5zm4.101-5.422c.057-.404.399-.635.798-.635a3.54 3.54 0 011.88.346l.342-1.615A4.808 4.808 0 0020.496 8c-1.88 0-3.248 1.039-3.248 2.481 0 1.097.969 1.673 1.653 2.02.74.346 1.025.577.968.923 0 .519-.57.75-1.139.75a4.795 4.795 0 01-1.994-.462l-.342 1.616a5.48 5.48 0 002.108.404c2.108.057 3.418-.981 3.418-2.539 0-1.962-2.678-2.077-2.678-2.942zm9.457 5.422L27.16 8.172h-1.652a.858.858 0 00-.798.577l-2.848 6.924h1.994l.398-1.096h2.45l.228 1.096h1.766zm-2.905-5.482l.57 2.827h-1.596l1.026-2.827z" />
            </svg> -->
            <div class="mt-3 text-left sm:ml-4 sm:mt-0">
              <div class="text-sm font-medium text-gray-900">
                Ajouter l'assignation
              </div>
              <div class="mt-1 text-sm text-gray-600 sm:flex sm:items-center">
                <div>Format word (.docx)</div>
                <!-- <span class="hidden sm:mx-2 sm:inline" aria-hidden="true">&middot;</span> -->
                <!-- <div class="mt-1 sm:mt-0">Last updated on 22 Aug 2017</div> -->
              </div>
            </div>
          </div>
          <div class="mt-4 sm:ml-6 sm:mt-0 sm:flex-shrink-0">
            <button @click="showModal = true" type="button" class="inline-flex items-center px-3 py-2 text-sm font-semibold text-gray-900 bg-white rounded-md shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
              <span><DocumentArrowUpIcon class="w-5 h-5 mr-3 text-gray-500" /></span>
              Ajouter
            </button>
          </div>
        </div>
      </div>
      <div>
        <!-- <FilePond
          v-model="newFiles"
          @update:modelValue="handleFiles"
        /> -->
        <!-- <FileInput @files-updated="(files) => newFiles = files" /> -->
      </div>
    </div>
  </div>

</template>
